import React, {useRef, useState, useEffect} from "react";
import {generateColumnClass, encodeImageToBase64} from "../../Utility";
import Image from "../Image";
import Icon from "../../ui/Icon";

const FileInput = (
    {
        name,
        value,
        error,
        label,
        onChange,
        onBlur,
        columns,
        placeholder,
        inline,
        isMultiple = false
    }) => {
    const columnClass = generateColumnClass(columns);
    const className = `${inline ? "d-flex flex-wrap " : ""}col-12${columnClass}`;
    const fileInputRef = useRef(null);

    const [encodedImage, setEncodedImage] = useState([]);
    const [image, setImage] = useState([]);

    const normalizeToArray = (val) =>
        val ? (Array.isArray(val) ? val : [val]) : [];

    useEffect(() => {
        // Sync initial value from backend
        setImage(normalizeToArray(value));
    }, [value]);

    const onChangeHandler = (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        if (isMultiple) {
            const encodedFiles = [];
            let processed = 0;

            files.forEach((file, index) => {
                encodeImageToBase64(file, (base64String) => {
                    encodedFiles[index] = base64String;
                    processed++;

                    if (processed === files.length) {
                        setImage(files);
                        setEncodedImage(encodedFiles);
                        onChange({
                            target: {
                                name,
                                value: files
                            }
                        });
                    }
                });
            });
        } else {
            const file = files[0];
            encodeImageToBase64(file, (base64String) => {
                setImage([file]);
                setEncodedImage([base64String]);
                onChange({
                    target: {
                        name,
                        value: file
                    }
                });
            });
        }
    };

    const imageClearHandler = () => {
        setImage([]);
        setEncodedImage([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
        onChange({
            target: {
                name,
                value: isMultiple ? [] : ""
            }
        });
    };

    const previews = encodedImage.length > 0 ? encodedImage : normalizeToArray(image);

    return (
        <div className={className}>
            {label && (
                <label
                    className={`form-label opacity-75${
                        inline ? " mb-0 py-2 col-12 col-md-4" : ""
                    }`}
                    htmlFor={name}
                >
                    {label}
                </label>
            )}

            <input
                type="file"
                className={`position-relative form-control${inline ? " col" : ""}`}
                name={name}
                placeholder={placeholder}
                ref={fileInputRef}
                onChange={onChangeHandler}
                onBlur={onBlur}
                id={name}
                multiple={isMultiple}
            />
            <div className="d-flex align-items-start gap-3 flex-wrap w-100 mt-2">
                {previews.map((src, index) => {
                    const file = image[index]; // The actual File object (if uploaded)
                    let isPdf = false;

                    if (file instanceof File) {
                        isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
                    } else if (typeof src === "string") {
                        // fallback check if only URL/string is available
                        isPdf = src.toLowerCase().endsWith(".pdf");
                    }

                    return (
                        <div className="position-relative" style={{width: "70px"}} key={index}>
                            <span
                                className="position-absolute top-0 start-100 translate-middle-x badge rounded-pill bg-secondary"
                                role="button"
                                onClick={imageClearHandler}>
                                x
                            </span>

                            {!isPdf ? (
                                encodedImage?.[index] ? (
                                    <img
                                        src={encodedImage[index]}
                                        alt={`img-${index}`}
                                        className="rounded-2"
                                        style={{width: "100%", height: "auto"}}
                                    />
                                ) : (
                                    <Image
                                        src={src}
                                        alt={`img-${index}`}
                                        className="rounded-2"
                                        style={{width: "100%", height: "auto"}}
                                    />
                                )
                            ) : (
                                <div className="d-flex flex-column align-items-center border rounded-2 p-2 bg-light"
                                     style={{width: "70px", height: "70px"}}>
                                    <Icon name="pdf"/>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>


            {error && (
                <div
                    className={`form-text text-start text-danger w-100${
                        inline && label ? " offset-md-4" : ""
                    }`}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

export default FileInput;
